import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Security } from '@okta/okta-react'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import { useNavigate } from 'react-router-dom'
import App from './App.tsx'
import { config } from './config'
import './index.css'

const oktaAuth = new OktaAuth({
  ...config.oidc,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'cache-control': 'no-cache',
  },
})

// Security wrapper component to handle navigation
const SecurityWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate()
  
  const restoreOriginalUri = (_oktaAuth: any, originalUri: any) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin))
  }

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <SecurityWrapper>
        <App />
      </SecurityWrapper>
    </BrowserRouter>
  </React.StrictMode>,
)
